module.exports = __webpack_public_path__ + "static/media/no data.8a2cd10b.svg";